import { useTranslation } from 'react-i18next';
import ProductModel from '../../../../components/model/ProductModel';
import { CreateButton } from '../../../../components/buttons/CreateButton';
import Modal from 'react-bootstrap/Modal';
import { BDSMForm } from '../../../../components/form/BDSMForm';
import React, { useState } from 'react';
import * as Yup from 'yup';

const ProductForm = ({ onClick, onCancel, record, productGroups }) => {
    const { t } = useTranslation('products');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const isEditing = record.id !== null;

    const validation = Yup.object().shape({
        groupId: Yup.string().test('test', t('validations:pleaseSelect'), (value) => value !== '-1'),
        title: Yup.string().required(t('validations:required')),
        proteins: Yup.string().required(t('validations:required')),
        fat: Yup.string().required(t('validations:required')),
        carbohydrates: Yup.string().required(t('validations:required')),
        energyValueKcal: Yup.string().required(t('validations:required')),
        water: Yup.string().required(t('validations:required')),
        dryMaterial: Yup.string().required(t('validations:required')),
        vegetableProtein: Yup.string().required(t('validations:required')),
        mineralSubstances: Yup.string().required(t('validations:required')),
        sodium: Yup.string().required(t('validations:required')),
        magnesium: Yup.string().required(t('validations:required')),
        phosphorus: Yup.string().required(t('validations:required')),
        potassium: Yup.string().required(t('validations:required')),
        calcium: Yup.string().required(t('validations:required')),
        iodine: Yup.string().required(t('validations:required')),
        vitaminB2: Yup.string().required(t('validations:required')),
        niacinVitaminPP: Yup.string().required(t('validations:required')),
        niacinEquivalent: Yup.string().required(t('validations:required')),
        vitaminB6: Yup.string().required(t('validations:required')),
        alcohol: Yup.string().required(t('validations:required')),
        energyKj: Yup.string().required(t('validations:required')),
        iron: Yup.string().required(t('validations:required')),
        vitaminB1: Yup.string().required(t('validations:required')),
        zinc: Yup.string().required(t('validations:required')),
        saturatedFattyAcids: Yup.string().required(t('validations:required')),
        monounsaturatedFattyAcids: Yup.string().required(t('validations:required')),
        polyunsaturatedFattyAcids: Yup.string().required(t('validations:required')),
        starch: Yup.string().required(t('validations:required')),
        fiberMaterials: Yup.string().required(t('validations:required')),
        selenium: Yup.string().required(t('validations:required')),
        vitaminARetinol: Yup.string().required(t('validations:required')),
        vitaminETocopherol: Yup.string().required(t('validations:required')),
        folicAcid: Yup.string().required(t('validations:required')),
        vitaminC: Yup.string().required(t('validations:required')),
        animalProtein: Yup.string().required(t('validations:required')),
        cholesterol: Yup.string().required(t('validations:required')),
        vitaminD: Yup.string().required(t('validations:required')),
        vitaminB12: Yup.string().required(t('validations:required')),
        sugar: Yup.string().required(t('validations:required')),
    });

    const handleSubmit = (values) => {
        onClick(values, record.id);
        onClose();
    };

    const onClose = () => {
        onCancel();
        handleClose();
    };

    const getFormModel = () => {
        return {
            initValues: record,
            onSubmit: (record) => handleSubmit(record),
            onCancel: () => onClose(),
            validationSchema: validation,
            fieldNames: ProductModel.fieldNames,
            types: ProductModel.fieldsTypes,
            className: 'mb-3',
            label: ProductModel.fieldNames.map((it) => t(it)),
            selectData: ProductModel.fieldNames.map((name) => name === 'groupId' ? productGroups : null),
            inputFieldsClass: '',
        };
    };

    return (
        <>
            <CreateButton onClick={handleShow} />
            <Modal show={show} onHide={onClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{isEditing ? t('updateProduct') : t('newProduct')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BDSMForm form={getFormModel()} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ProductForm;
